import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const statsContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

const statCard = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const Stats = () => {
  return (
    <section className="stats-section">
      <div className="container hero-container">
        <motion.p
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Leading Holistic Healing for Nearly Two Decades
        </motion.p>

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Kutch’s First Fully Functional Ayurveda Treatment Center
        </motion.h2>

        <motion.div
          className="stats-grid"
          variants={statsContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.3,
          }}
        >
          <motion.div
            className="hero-stat"
            variants={statCard}
          >
            <h3>
              <CountUp
                end={19}
                duration={3}
                delay={1}
                enableScrollSpy
                scrollSpyOnce
              />
              +
            </h3>
            <p>Years of Experience</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statCard}
          >
            <h3>
              <CountUp
                end={25000}
                separator=","
                duration={3}
                delay={1}
                enableScrollSpy
                scrollSpyOnce
              />
              +
            </h3>
            <p>Patients Treated</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statCard}
          >
            <h3>
              <CountUp
                end={100}
                duration={3}
                delay={1}
                enableScrollSpy
                scrollSpyOnce
              />
              %
            </h3>
            <p>Ayurvedic Treatments</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statCard}
          >
            <h3>
              <CountUp
                end={4.9}
                decimals={1}
                duration={3}
                delay={1}
                enableScrollSpy
                scrollSpyOnce
              />
              /5
            </h3>
            <p>Google Rating</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Stats;